import { j as e } from "../../../../../../../jsx-runtime.BREq8dyb.js";
import { faInfoCircle as i } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon as d } from "@fortawesome/react-fontawesome";
import { Stack as p, FormControl as f, FormLabel as u, Box as x, Tooltip as j, Link as g, Input as b, FormHelperText as h } from "@mui/joy";
import { memo as C } from "react";
import { b as S, C as k } from "../../../../../../../react-hook-form.Du3weLRK.js";
import { S as y } from "../../../../../../../index.BRz-o-Vs.js";
import o from "../../../../DqDatasetSyncControlledInput/DqDatasetSyncControlledInput.js";
import { g as F } from "../../../../../../../index._aEPM5Ps.js";
import I from "../../labels/ConfigurationLabel/ConfigurationLabel.js";
import N from "../../labels/CredentialsLabel/CredentialsLabel.js";
const T = C(({
  syncDirection: s
}) => {
  const {
    control: n,
    setError: m
  } = S();
  return /* @__PURE__ */ e.jsxs(p, { children: [
    /* @__PURE__ */ e.jsx(I, {}),
    /* @__PURE__ */ e.jsx(o, { label: "Bucket name", name: "gcs.bucketName", placeholder: 'e.g. "bucket-name"' }),
    /* @__PURE__ */ e.jsx(o, { label: "Object name", name: "gcs.objectName", placeholder: 'e.g. "object-name"' }),
    s === y.IMPORT ? /* @__PURE__ */ e.jsx(o, { label: "Stored dataset name", name: "datasetName", placeholder: 'e.g. "dataset-name"', required: !1 }) : null,
    /* @__PURE__ */ e.jsx(N, {}),
    /* @__PURE__ */ e.jsx(k, { control: n, name: "gcs.credentials", render: ({
      field: {
        disabled: r,
        value: L = "",
        ...t
      },
      fieldState: {
        error: a
      },
      formState: {
        isSubmitting: l
      }
    }) => /* @__PURE__ */ e.jsxs(f, { disabled: r || l, error: !!a, required: !0, children: [
      /* @__PURE__ */ e.jsxs(u, { children: [
        "Service account key in JSON format",
        /* @__PURE__ */ e.jsx(x, { ml: 0.5, children: /* @__PURE__ */ e.jsx(j, { title: /* @__PURE__ */ e.jsxs("span", { children: [
          "Please",
          " ",
          /* @__PURE__ */ e.jsx(g, { href: "https://cloud.google.com/iam/docs/keys-create-delete#creating", rel: "noreferrer", target: "_blank", children: "follow the instructions" }),
          " ",
          "to obtain a service account key"
        ] }), children: /* @__PURE__ */ e.jsx(d, { icon: i }) }) })
      ] }),
      /* @__PURE__ */ e.jsx(b, { ...t, disabled: r || l, slotProps: F((c) => m(t.name, c)) }),
      /* @__PURE__ */ e.jsx(h, { children: a?.message })
    ] }) }, "gcs.credentials")
  ] });
});
T.displayName = "GoogleCloudStorageFormControls";
export {
  T as default
};
//# sourceMappingURL=GoogleCloudStorageFormControls.js.map
